import { Col, InputField, Label, ReactSelectBox, Row, SwitchToggle } from "client/CommonComponents"
import './Location.scss'
import { MaskedTextField } from '@fluentui/react';
import { isNumber } from "utils";

const Location = (props: any) => {
    const {
        cityOnChange,
        stateOnChange,
        toggleSameAsBranch,
        sameAsBranch,
        assetLocation,
        assetLocationNameOnChange,
        assetLocationContactNameOnChange,
        assetLocationEmailOnChange,
        assetLocationContactPhoneOnChange,
        assetLocationAddress1OnChange,
        assetLocationAddress2OnChange,
        assetLocationZipOnChange,
        dispositionData,
        AssetDispostionFieldRef,
        addressSearchText,
        addressListLoad,
        addressDropDownListTemp,
        filterLocationOptionAddress1
    } = props
    return (
        <div className="p-3">
            <SwitchToggle checked={sameAsBranch} label='Same as Branch' className="location-switchToggle" onChange={toggleSameAsBranch}  data-attribute="Location_Same_as_Branch_SwitchToggle" />
            <Row>
                <Col xs={12} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="Location_Default_Label">Location Name</Label>
                    <InputField
                        name='assetLocationName'
                        placeholder="Enter Location Name"
                        value={assetLocation?.assetLocationName ? assetLocation?.assetLocationName : ''}
                        onChange={(e: any) => assetLocationNameOnChange(e)}
                        inputRef={(element: any) => AssetDispostionFieldRef.current[2] = element}
                        className={dispositionData?.assetLocationNameError ? 'controlValidation form-input' : 'form-input'}
                     data-attribute="Location_assetLocationName_Input" />
                    {dispositionData?.assetLocationNameError ? <p className='validMessage'>{dispositionData?.assetLocationNameError}</p> : ""}
                </Col>
                <Col xs={12} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="Location_Default_Label_2">Contact Name</Label>
                    <InputField
                        name='assetLocationContactName'
                        placeholder="Enter Contact Name"
                        value={assetLocation?.assetLocationContactName ? assetLocation?.assetLocationContactName : ''}
                        onChange={(e: any) => assetLocationContactNameOnChange(e)}
                        className={dispositionData?.assetLocationContactNameError ? 'controlValidation form-input' : 'form-input'}
                     data-attribute="Location_assetLocationContactName_Input" />
                    {dispositionData?.assetLocationContactNameError ? <p className='validMessage'>{dispositionData?.assetLocationContactNameError}</p> : ""}
                </Col>
                <Col xs={12} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="Location_Default_Label_3">Email</Label>
                    <InputField
                        name='assetLocationEmail'
                        placeholder="Enter Email Address"
                        value={assetLocation?.assetLocationEmail ? assetLocation?.assetLocationEmail : ''}
                        onChange={(e: any) => assetLocationEmailOnChange(e)}
                        className={dispositionData?.assetLocationEmailError ? 'controlValidation form-input' : 'form-input'}
                     data-attribute="Location_assetLocationEmail_Input" />
                    {dispositionData?.assetLocationEmailError ? <p className='validMessage'>{dispositionData?.assetLocationEmailError}</p> : ""}
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="Location_Default_Label_4">Contact Phone #</Label>
                    <MaskedTextField
                        name='assetLocationContactPhone'
                        className={dispositionData?.assetLocationContactPhoneError ? 'controlValidation form-input' : 'form-input'}
                        mask="999-999-9999"
                        placeholder='Enter Phone'
                        onChange={(e: any, value: any) => assetLocationContactPhoneOnChange(e, value)}
                        value={assetLocation?.assetLocationContactPhone || ""}
                    />
                    {dispositionData?.assetLocationContactPhoneError ? <p className='validMessage'>{dispositionData?.assetLocationContactPhoneError}</p> : ""}
                </Col>
                <Col xs={12} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="Location_Default_Label_5">Address 1</Label>
                        <ReactSelectBox
                            options={addressDropDownListTemp}
                            onChange={(e: any, item: any) => assetLocationAddress1OnChange(e, item)}
                            value={assetLocation?.assetLocationAddress1?.length ? { label: assetLocation?.assetLocationAddress1, text: assetLocation?.assetLocationAddress1 } : ""}
                            placeholder="Search"
                            isSearchable={true}
                            isLoading={addressListLoad}
                            inputValue={addressSearchText}
                            noOptionsMessage={() => "Not Available"}
                            isClearable = {true}
                            onInputChange={(value: any, action: any) => filterLocationOptionAddress1(value, action)}
                            className={dispositionData?.assetLocationAddress1Error ? 'controlValidation form-input' : 'form-input'}
                         data-attribute="Location_Default_SearchSelectBox" />
                        {dispositionData?.assetLocationAddress1Error ? <p className='validMessage'>{dispositionData?.assetLocationAddress1Error}</p> : ""}
                </Col>
                <Col xs={12} md={4} lg={4} className='mb-3'>
                    <Label data-attribute="Location_Default_Label_6">Address 2</Label>
                    <InputField
                        name='assetLocationAddress2'
                        placeholder="Enter Address 2"
                        value={assetLocation?.assetLocationAddress2 || ""}
                        onChange={(e: any) => assetLocationAddress2OnChange(e)}
                        className={dispositionData?.assetLocationAddress2Error ? 'controlValidation form-input' : 'form-input'}
                     data-attribute="Location_assetLocationAddress2_Input" />
                    {dispositionData?.assetLocationAddress2Error ? <p className='validMessage'>{dispositionData?.assetLocationAddress2Error}</p> : ""}
                </Col>
            </Row>
            <Row>                
                <Col xs={12} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="Location_Default_Label_7">State</Label>
                        <InputField
                            name='assetLocationState'
                            placeholder="Enter State"
                            value={assetLocation?.assetLocationState}
                            onChange={(e?: any, item?: any) => { stateOnChange(e, item) }} 
                            className={dispositionData?.assetLocationStateError ? 'controlValidation form-input' : 'form-input'} data-attribute="Location_assetLocationState_Input" />
                    {dispositionData?.assetLocationStateError ? <p className='validMessage'>{dispositionData?.assetLocationStateError}</p> : ""}
                </Col>    
                <Col xs={12} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="Location_Default_Label_8">City</Label>
                     <InputField
                            name='assetLocationCity'
                            placeholder="Enter City"
                            value={assetLocation?.assetLocationCity}
                            onChange={(e?: any, item?: any) => { cityOnChange(e, item) }} 
                            className={dispositionData?.assetLocationCityError ? 'controlValidation form-input' : 'form-input'} data-attribute="Location_assetLocationCity_Input" />
                    {dispositionData?.assetLocationCityError ? <p className='validMessage'>{dispositionData?.assetLocationCityError}</p> : ""}
                </Col>          
                <Col xs={12} md={4} lg={4} className='mb-3'>
                    <Label required data-attribute="Location_Default_Label_9">Zip</Label>
                    <InputField
                        name='assetLocationZip'
                        placeholder="Enter Zip"
                        value={assetLocation?.assetLocationZip || ""}
                        onChange={(e: any) => assetLocationZipOnChange(e)}
                        onKeyPress={(event: any) => { isNumber(event) }}
                        className={dispositionData?.assetLocationZipError ? 'controlValidation form-input' : 'form-input'}
                     data-attribute="Location_assetLocationZip_Input" />
                    {dispositionData?.assetLocationZipError ? <p className='validMessage'>{dispositionData?.assetLocationZipError}</p> : ""}
                </Col>
            </Row>

        </div>
    )


}

export default Location